import 'highlight.js/styles/github.css';
import './custom-react-markdown.css';

import ReactMarkdown from 'react-markdown';
import rehypeHighlight from 'rehype-highlight';
import remarkGfm from 'remark-gfm';

interface CustomReactMarkdownProps {
  children: string;
  className?: string;
  isError?: boolean;
}

const CustomReactMarkdown = ({
  children,
  className = '',
  isError = false,
}: CustomReactMarkdownProps) => {
  return (
    <div className={`markdown-body ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeHighlight]}
        components={{
          img: (props) => <img style={{ maxWidth: '100%' }} {...props} />,
          a: (props) => (
            <a target="_blank" rel="noopener noreferrer" style={{ color: 'blue' }} {...props} />
          ),
          code: ({ className, children, ...props }) => {
            const language = className?.replace('language-', '');
            return className ? (
              <div className="code-block">
                {language && <div className="language-tag">{language}</div>}
                <code className={className} {...props}>
                  {children}
                </code>
              </div>
            ) : (
              <code className={className} {...props}>
                {children}
              </code>
            );
          },
          ol: (props) => <ol style={{ paddingLeft: '20px' }} {...props} />,
          ul: (props) => <ul style={{ paddingLeft: '20px' }} {...props} />,
          li: (props) => <li style={{ marginBottom: '4px' }} {...props} />,
          p: (props) => <p {...props} style={{ color: isError ? '#FA0000' : undefined }} />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
};

export default CustomReactMarkdown;
